module.exports = __webpack_public_path__ + "static/media/lk.49fae8fd.svg";